import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'

import useAttachments from '@hooks/useAttachments'
import useOrder from '@hooks/useOrder'
import useOrderItem from '@hooks/useOrderItem'

import type { OrderItemModel } from '@models/types'

const useManageOrderItem = (initOrderItem: OrderItemModel) => {
  const orderItemPayload = useOrderItem(initOrderItem)
  const {
    callbacks: {
      deleteOrderItem: deleteOrderItemFn,
      duplicateOrderItem: duplicateOrderItemFn,
      editPublicationEdition,
      manageTasks,
      updateOrderItem: updateOrderItemFn,
    },
    campaign,
    isDeletable,
    isDuplicatable,
    isPending,
    isPublicationOrder,
    isReorderable,
    isTaskable,
    order,
    orderItem,
    requiredItems,
  } = orderItemPayload

  const orderPayload = useOrder(order)
  const {
    callbacks: {
      addLiftover,
      createOrderWithOrderItem,
    },
    creating: creatingOrder,
  } = orderPayload

  useAttachments({
    filters: {
      attachable_id: campaign.id,
      attachable_type: 'Campaign',
      attachment_type: 'artwork_backup',
    },
    performHttpRequests: !!campaign.id,
  })

  const requiredDateString = digObject(orderItem, 'dates.required.date_time')
  const requiredBy = requiredDateString
    ? DateTime.fromFormat(requiredDateString, 'dd/MM/yyyy HH:mm').toFormat("yyyy-MM-dd'T'HH:mm")
    : ''

  const artworkRequired = digObject(requiredItems, 'artwork', false)

  const showMoreOptions = isPublicationOrder
    || isDeletable
    || isDuplicatable
    || isReorderable
    || (!isPending && isTaskable)

  return {
    artworkRequired,
    callbacks: {
      addLiftover,
      createOrderWithOrderItem,
      deleteOrderItemFn,
      duplicateOrderItemFn,
      editPublicationEdition,
      manageTasks,
      updateOrderItemFn,
    },
    creatingOrder,
    orderItemPayload,
    requiredBy,
    showMoreOptions,
  }
}

export default useManageOrderItem
